import React from 'react';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const platformStats = {
    totalCreators: 156,
    activeChannels: 10,
    totalViews: '2.4M',
    totalRevenue: '₹45,230',
    monthlyGrowth: '+12.5%',
    activeProjects: 48,
    totalInvestors: 324,
    platformCommission: '₹8,450'
  };

  const recentActivities = [
    { id: 1, type: 'upload', message: 'New video uploaded to Health channel', time: '5 min ago' },
    { id: 2, type: 'investment', message: 'New investment of ₹50,000 in Tech Reviews', time: '1 hour ago' },
    { id: 3, type: 'payout', message: 'Monthly payout processed for 23 creators', time: '3 hours ago' }
  ];

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h2>Platform Admin Dashboard</h2>
        <p>Manage the entire Choice Network MCN Platform</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card primary">
          <h3>Total Creators</h3>
          <p className="stat-value">{platformStats.totalCreators}</p>
          <span className="stat-change positive">+23 this month</span>
        </div>
        <div className="stat-card success">
          <h3>Active Channels</h3>
          <p className="stat-value">{platformStats.activeChannels}</p>
          <span className="stat-change positive">+2 new channels</span>
        </div>
        <div className="stat-card info">
          <h3>Total Views</h3>
          <p className="stat-value">{platformStats.totalViews}</p>
          <span className="stat-change positive">{platformStats.monthlyGrowth}</span>
        </div>
        <div className="stat-card warning">
          <h3>Platform Revenue</h3>
          <p className="stat-value">{platformStats.totalRevenue}</p>
          <span className="stat-change positive">+8.2% MoM</span>
        </div>
      </div>

      <div className="dashboard-grid">
        <div className="recent-activities">
          <h3>Recent Platform Activities</h3>
          <ul>
            {recentActivities.map(activity => (
              <li key={activity.id} className="activity-item">
                <span className={`activity-type ${activity.type}`}></span>
                <div>
                  <p>{activity.message}</p>
                  <small>{activity.time}</small>
                </div>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="quick-actions">
          <h3>Admin Actions</h3>
          <button className="action-btn">Manage Channels</button>
          <button className="action-btn">Review Payouts</button>
          <button className="action-btn">Platform Settings</button>
          <button className="action-btn">Generate Reports</button>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
